import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ReportResponse} from "../../../../shared/model/response/report-response";
import {Menu} from "primeng/menu";
import {MenuItem} from "primeng/api";
import {ModalService} from "../../../../service/modal.service";
import {MessageToastService} from "../../../../service/message-toast.service";
import {Router} from "@angular/router";
import {ComplaintStatus} from "../../../../shared/enums/status.enum";
import {take} from "rxjs";
import {ReportService} from "../../../../service/api/report.service";

@Component({
    selector: 'app-complaint-drop-down',
    templateUrl: './complaint-drop-down.component.html',
    standalone: false
})
export class ComplaintDropDownComponent implements OnInit {

  @ViewChild('menu') menu: Menu

  @Input('complaint') report: ReportResponse

  @Input('clickEvent')
  set mouseEvent(mouseEvent: MouseEvent) {
    this.initMenu()
    this.menu?.toggle(mouseEvent)
  }

  @Output('onCloseComplaintSuccess') closeComplaintSuccessEmiter = new EventEmitter<ReportResponse>()

  items: MenuItem[] | undefined;

  showComplaintModal = false

  constructor(
    private modalService: ModalService,
    private reportService: ReportService,
    private messageService: MessageToastService,
    private router: Router
  ) {
  }

  //------------------------------

  ngOnInit(): void {

  }

  initMenu() {
    this.items = [
      {
        items: [
          {
            visible: true,
            label: 'Visualizar',
            icon: 'pi pi-eye',
            command: () => this.showComplaintModal = true
          },
          {
            visible: true,
            label: 'Ir a Ocorrência',
            icon: 'pi pi-arrow-up-right',
            command: () => this.router.navigate(['/ocorrencia/' + this.report.eventSlug]).then()
          },
          {
            visible: this.report?.eventStatus?.code === ComplaintStatus.PENDING,
            label: 'Fechar Denúncia',
            icon: 'pi pi-check',
            command: () => this.onCloseComplaint()
          }
        ]
      }
    ];
  }

  // complaint actions
  onCloseComplaint() {
    this.modalService.simpleConfirmation({
      message: "Tem certeza que pretende alterar o estado da denúncia para Fechado?"
    })
      .then(confirmed => {
        if (confirmed) {
          this.apiCloseComplaint()
        }
      })
  }

  //api calls
  apiCloseComplaint() {
    this.reportService.closeComplaint(this.report.id).pipe(take(1)).subscribe({
      next: value => {
        this.messageService.success(value.message)
        this.closeComplaintSuccessEmiter.emit(this.report)
      },
      error: err => this.messageService.error(err.message)
    })
  }

}
